import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import { clearAll, onAddEvaluation, setErrorMessageNotapUser, setLoadingNotapUser, showCommentRichTextFormFunc } from '../../../../config/redux/slice/notapUserSlice';
import { getRequest } from '../../../../helpers/request';
import { postRequest } from '../../../../helpers/request';
import { appApi } from '../../../../utils/endpoints/appApi';
import { Spinner } from '../../../components';

import Editor from '../../../components/Editor';

export default function AddEvaluationModal() {
  const dispatch = useDispatch()
  const { handleSubmit } = useForm({mode: 'onTouched'})

    const {
      notapUserLoading,
      notapUserErrorMsg,
      notapUserSuccessMsg,
      certificateManagement:{certificateDetails},
      evaluationManagement: {evalStatus, evalId, evaluationDetails}
    } = useSelector((state) => state.notapUser)

    const {
        token,
        userData: {user_role, user_role_id}
    } = useSelector((state) => state.authData)

      const [letter, setLetter]=useState(evaluationDetails.STATUS == 'draft' ? evaluationDetails.LETTER : certificateDetails.LETTER == 'N/A' ? '' : certificateDetails.LETTER);
  const [comments, setComment]=useState(evaluationDetails == '' ? evaluationDetails : evaluationDetails.COMMENTS);
  const [sentTo, setSentTo] = useState({})


useEffect(()=>{
        getNotapStaff()
    }, [])

    const getNotapStaff = async () => {
    dispatch(clearAll({}))

    const res = await getRequest(
        token,
        `${appApi.getStaff}`,
        {},
        dispatch,
        setLoadingNotapUser,
        "",
        setErrorMessageNotapUser,
    ) 
    if(res != undefined && res.status < 400){
        let dataList = res.data.data
        let nextUser;
        if(user_role.toLowerCase() == 'officers'){
            nextUser = dataList.filter((dataObj)=>(Number(user_role_id)-1) == dataObj.USER_ROLE_ID)
        }else if(user_role.toLowerCase() == 'dg'){
            nextUser = dataList.filter((dataObj)=>(Number(user_role_id)+1) == dataObj.USER_ROLE_ID)
        }
        else if(certificateDetails?.EVALUATION_DIRECTION == 'backward'){
            nextUser = dataList.filter((dataObj)=>(Number(user_role_id)-1) == dataObj.USER_ROLE_ID)
        }else if(certificateDetails?.EVALUATION_DIRECTION == 'forward'){
            nextUser = dataList.filter((dataObj)=>(Number(user_role_id)+1) == dataObj.USER_ROLE_ID)
        }
        setSentTo(nextUser[0])
    }
   }

  const closeModal = ()=>{
      dispatch(showCommentRichTextFormFunc({modal:false, status: '', evalId: null}))
  }

    const formRef2 = React.useRef(null);

 
     const onSubmitEvaluation = async (data) => {
    dispatch(clearAll({}))
        data = {
                comment: comments,
                letter,
                certificate_id: certificateDetails?.ID,
                next_user_email: sentTo.EMAIL,
                next_user_name: `${sentTo.FIRST_NAME} ${sentTo.LAST_NAME}`,
                status: evalStatus,
                evaluation_id: evalId
            }

        const res = await postRequest(
            token,
            `${appApi.submitEvaluation}`,
            data,
            dispatch,
            setLoadingNotapUser,
            onAddEvaluation,
            setErrorMessageNotapUser,
        ) 
    // }    
   }
  return (
    <div 
        className="modal fade show" 
        id="basicModal" 
        tabIndex="-1"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.3)",
          overflowY: 'auto'
        }}
     >

      <div style={{overflowY: 'auto'}} className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
            <div className="email-right-column app email-body p-2 p-sm-3 p-md-4 p-xl-5">
              <div className="modal-header px-4">
                <h5 className="modal-title font-weight-bold" id="exampleModalCenterTitle">Add Evaluation</h5>
                <button 
                  type="button" 
                  className="close" 
                  data-dismiss="modal" 
                  aria-label="Close"
                  onClick={()=>{closeModal()}}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>

              <div className='modal-body'>
                <form ref={formRef2} className="email-compose" onSubmit={handleSubmit(onSubmitEvaluation)} noValidate>
                    <div className='mt-4'>
                      <label>Comment</label>
                      <Editor value={comments} onChange={setComment} />
                    </div>

                    <div>
                        <label>Compose Letter</label>
                        <Editor value={letter} onChange={setLetter} />
                    </div>
                  
                    <div>
                      {notapUserLoading ? <Spinner/> : <button className="btn btn-primary btn-pill mb-5 mt-3" type="submit">Send Evaluation</button>}
                    </div>
                </form>
              </div>
            </div>
        </div>
      </div>
    </div>
  )
}
